import { Banner } from "../../../components/Banner";
import { Button } from "../../../components/Button";
import { Divider } from "../../../components/Divider";
import { StatusDot } from "../../../components/StatusDot";
import { Section } from "../DesignSystem";

const row: React.CSSProperties = {
  display: "flex",
  gap: "var(--space-6)",
  flexWrap: "wrap",
  marginBottom: "var(--space-6)",
};

export const StatusSection = () => (
  <Section label="09 · Components" title="Status & Feedback">
    <div style={row}>
      <StatusDot tone="ok">All clear · 2m ago</StatusDot>
      <StatusDot tone="warn">NVR offline · 6h 34m</StatusDot>
      <StatusDot tone="error">Camera offline · 1d</StatusDot>
      <StatusDot tone="muted">Motion · 11m ago</StatusDot>
    </div>
    <Divider />
    <div style={{ display: "flex", flexDirection: "column", gap: "var(--space-4)" }}>
      <Banner tone="info">
        New here? Your installer will have invited you by email. If the invite's gone stale, request
        a fresh link.
      </Banner>
      <Banner
        tone="warn"
        title="Couldn't reach 192.168.1.64 on RTSP 554."
        actions={
          <Button size="sm" variant="outline">
            Troubleshoot
          </Button>
        }
      >
        Check the NVR is on, its Ethernet is plugged in, and the login is right.
      </Banner>
      <Banner tone="success">Changes saved. Members will see this next time they sign in.</Banner>
    </div>
  </Section>
);
